module.exports = __webpack_public_path__ + "static/media/arrowRight.f9abbe91.svg";